import Gallery from '@/component/photoGallery/index';

export const ImageCategoryTile = ({ imageCategory }) => {
  return (
    <>
      <div className="flex flex-col !gap-6 max-sm:w-full max-sm:min-w-full sm:w-[334px] sm:min-w-[334px]">
        <h3 className="text-slate-700 text-lg font-semibold tracking-tight">
          {imageCategory.name}
        </h3>
        {imageCategory.images?.[0] && (
          <Gallery images={imageCategory.images} singleImage />
        )}
        <div className="flex flex-col gap-[6px]">
          {imageCategory.images?.[0]?.caption && (
            <p className="text-slate-500 text-base">
              {imageCategory.images?.[0]?.caption}
            </p>
          )}
        </div>
      </div>
    </>
  );
};
